import { useBunja } from 'bunja/react';
import { isEmpty } from 'es-toolkit/compat';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { HaveNoPositions } from '@flipster/features/src/shared/position/have-no-positions';
import { RadioButton } from '@flipster/react/design-system/radio-button';
import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import { Table, TableHeader } from '@flipster/ui/Table';

import { pendingPositionTableBunja } from '../state';
import { positionTableCss } from '../table-styles';
import PendingPositionRow from './pending-position-row';

const PendingPositionTable = () => {
  const t = useTranslations();
  const {
    pendingPositionTypeAtom,
    pendingTableColumnsAtom,
    pendingOrdersAtom,
    pendingOrderCountAtom,
    selectedPendingOrdersAtom,
  } = useBunja(pendingPositionTableBunja);

  const [selectedOrderType, setSelectedOrderType] = useAtom(pendingPositionTypeAtom);
  const pendingOrders = useAtomValue(pendingOrdersAtom);
  const selectedPendingOrders = useAtomValue(selectedPendingOrdersAtom);
  const columns = useAtomValue(pendingTableColumnsAtom);
  const pendingPositionCount = useAtomValue(pendingOrderCountAtom);

  if (isEmpty(pendingOrders)) return <HaveNoPositions css={{ mt: 16 }} positionType='pending' />;

  return (
    <>
      <div className={flex({ gap: 20, textStyle: 'Text/L/Regular', pt: 8, pb: 4, pos: 'sticky', left: 0 })}>
        <RadioButton
          name='position-tab'
          value='limit'
          checked={selectedOrderType === 'limit'}
          onChange={() => setSelectedOrderType('limit')}
        >
          <span
            className={css({
              color: selectedOrderType === 'limit' ? 'content.default.level-5' : 'content.default.level-1',
            })}
          >
            {t('Trade.r251104.Limit')} ({pendingPositionCount.limit})
          </span>
        </RadioButton>
        <RadioButton
          name='position-tab'
          value='trigger'
          checked={selectedOrderType === 'trigger'}
          onChange={() => setSelectedOrderType('trigger')}
        >
          <span
            className={css({
              color: selectedOrderType === 'trigger' ? 'content.default.level-5' : 'content.default.level-1',
            })}
          >
            {t('Trade.r251008.Trigger')} ({pendingPositionCount.trigger})
          </span>
        </RadioButton>
      </div>

      <Table
        className={positionTableCss}
        tHeader={<TableHeader columns={columns} />}
        items={selectedPendingOrders}
        renderRow={(position, index) => <PendingPositionRow key={position.orderId} item={position} index={index} />}
        withHover
      />
    </>
  );
};

export default PendingPositionTable;
